<template>
  <div>
    <!-- table responsive -->
    <div class="d-flex mt-3 mb-3 d-flex flex-wrap">
      <div class="me-2 ta-right w-250px">
        <b-form-group description="Filter by status">
          <multiselect v-model="status" :options="statusOptions" track-by="value" label="text"
            select-label="Click to select" deselect-label="Click to remove" placeholder="Select status"
            :allow-empty="false" :preselect-first="true"></multiselect>
        </b-form-group>
      </div>
      <div class="me-2 ta-right w-250px">
        <b-form-group description="Filter by activity">
          <multiselect v-model="subModule" :options="subModuleOptions" track-by="value" label="text"
            select-label="Click to select" deselect-label="Click to remove" placeholder="Select activity"
            :allow-empty="false" :preselect-first="true"></multiselect>
        </b-form-group>
      </div>
      <div class="me-3 ta-right">
        <b-form-group description="Filter by date">
          <flat-pickr v-model="lookupParams.dateRange" :config="rangeOptions"
            placeholder="Select a date range" class="form-control"></flat-pickr>
        </b-form-group>
      </div>
      <div class="">
        <b-form-group label="">
          <b-button variant="primary" type="button" @click="onSearch" class="px-2 btn btn-primary h-fit me-2">
            <i class='bx bx-search bx-fw'></i> Search
          </b-button>
        </b-form-group>
      </div>
    </div>
    <div class="table-responsive">
      <div class="table align-middle table-nowrap">
        <b-table
          :items="mopReasonLoglist"
          :fields="fieldsMop"
          :no-local-sorting="true" 
          @sort-changed="handleSort"
        > 
          <template #cell(status)="data">
            <span>
              {{ data.item.status == 'a' ? 'Active' : 'Inactive' }}
            </span>
          </template>
          <template #cell(createdAt)="data">
            {{data.item.created_at | standardDate}}
          </template>
        </b-table>
      </div>
    </div>
    <!-- end table responsive -->
    <div class="row g-0 text-center" v-if="mopReasonLoglistTotalRows == 0">
      <span>No data to display.</span>
    </div>
    <!-- pagination -->
    <div
      class="row g-0 text-center text-sm-start"
      v-if="mopReasonLoglistTotalRows != 0 && mopReasonLoglistTotalRows > 10"
    >
      <!-- end col -->
      <div class="col-sm-12">
        <div class="row">
          <div class="col">
            <div class="form-group row pull-left">
              <label for="staticEmail" class="col-sm-6 col-form-label"
                >Display:</label
              >
              <div class="col-sm-6">
                <b-form-group label-for="display-record">
                  <b-form-select
                    class="form-select shadow-none w-fit"
                    id="display-record"
                    v-model="pagination.rows"
                    :options="pageOptions"
                    @change="listReasonLogs()"
                  ></b-form-select>
                </b-form-group>
              </div>
            </div>
            <div class="dataTables_paginate paging_simple_numbers float-end">
              <b-pagination
                class="pagination-rounded"
                v-model="pagination.page"
                @input="listReasonLogs()"
                :total-rows="mopReasonLoglistTotalRows"
                :per-page="pagination.rows"
              ></b-pagination>
            </div>
          </div>
        </div>
      </div>
      <!-- end col -->
    </div>
    <!-- end pagination -->
  </div>
</template>

<script>
import { layoutMethods, mopMethods, mopComputed } from '@/state/helpers';
import moment from 'moment';
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Multiselect from "vue-multiselect";

export default {
  data() {
    return {
      campaigns: [],
      totalRows: 1,
      currentPage: 1,
      pageOptions: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
      statusOptions: [
        {value: null, text: 'All'},
        {value: 'a', text: 'Active'},
        {value: 'i', text: 'Inactive'}
      ],
      subModuleOptions: [
        {value: null, text: 'All'},
        {value: 'MOP_STATUS_UPDATE', text: 'Main MOP'},
        {value: 'MODULE_MOP_STATUS_UPDATE', text: 'Module MOP'}
      ],
      fieldsMop: [
        {
          key: 'status',
          label: 'MOP Status',
          sortable: true,
        },
        {
          key: 'remarks',
          label: 'Activity',
          sortable: true,
        },
        {
          key: 'reason',
          label: 'Reason',
          sortable: true,
        },
        {
          key: 'createdAt',
          label: 'Date Created',
          sortable: true,
        },
        {
          key: 'actor',
          label: 'Modified By',
          sortable: true,
        }
      ],
      pagination: {
        rows: 10,
        page: 1,
        sort: 'id',
        orderDesc: true
      },
      lookupParams: {
        status: '',
        subModule: '',
        dateRange: ''
      },
      rangeOptions: {
        mode: "range",
        maxDate: "today"
      },
      eloadTopupsModule: {
        access: {
          create: true,
          update: true,
          delete: true
        }
      }
    }
  },
  methods: {
    ...layoutMethods,
    ...mopMethods,
    handleSort(ctx) {
      console.log(ctx);
      this.pagination.sort = ctx.sortBy;
      this.pagination.orderDesc = ctx.sortDesc;
      this.listReasonLogs();
    },
    onSearch(){
      this.pagination = Object.assign(this.pagination, this.lookupParams);
      this.listReasonLogs();
    },
    onRefresh(){
      this.listReasonLogs();
    },
    checkDate(date){
      var r = (new Date(date) !== "Invalid Date") && !isNaN(new Date(date));
      r = date == null ? false:r
      return r;
    },
    listReasonLogs(){
      this.getMopReasonList(this.pagination);
    }
  },
  computed: {
    ...mopComputed,
    status: {
      get() {
        var status = null;
        this.statusOptions.forEach((s) => {
          if (s.value == this.lookupParams.status) {
            status = s;
          }
        });
        return status;
      },
      set(status) {
        if (status) {
          this.lookupParams.status = status.value;
        } else {
          this.lookupParams.status = null;
        }
      }
    },
    subModule: {
      get() {
        var subModule = null;
        this.subModuleOptions.forEach((s) => {
          if (s.value == this.lookupParams.subModule) {
            subModule = s;
          }
        });
        return subModule;
      },
      set(subModule) {
        if (subModule) {
          this.lookupParams.subModule = subModule.value;
        } else {
          this.lookupParams.subModule = null;
        }
      }
    },
  },
  components: {
    flatPickr,
    Multiselect
  },
  mounted(){
    this.listReasonLogs();
  },
  filters: {
    standardDate: function(value){
      return moment(value).format('MMM DD, YYYY, h:mm A')
    }
  }
};
</script>

<style>
.status {
  font-weight: bold;
}

.status-green {
  color: #139613;
}

.status-grey {
  color: #AAAAAA;
}

.status-black {
  color: #000;
}

.w-200px {
  width: 200px;
}

.w-250px {
  width: 250px;
}

.w-350px {
  width: 350px;
}

.campaign-purchase-export {
  cursor: pointer;
}
</style>